export const SHOW_LOADER = '@@globalLoader/SHOW_LOADER';
export const HIDE_LOADER = '@@globalLoader/HIDE_LOADER';

interface GlobalLoaderAction {
  type: typeof SHOW_LOADER | typeof HIDE_LOADER;
}

export interface GlobalLoaderState {
  loading: boolean;
}

export type GlobalLoaderTypes = GlobalLoaderAction;
